<template>
  <div class="about-page">
    <section class="about-hero">
      <h1>Technology at the Core, Building Diversified Operating Capabilities</h1>
      <p class="desc">
        Built on technical services, technical development and technical consulting, we extend into
        diversified business segments including IoT R&amp;D, AI hardware, electronic products, jewelry
        and daily necessities, supported by domestic trade agency, online sales, import &amp; export
        agency and international freight forwarding, providing customers with stable and reliable
        cooperation support.
      </p>
    </section>

    <div class="content-body">
      <section class="about-grid">
        <article class="card">
          <h3>Technical Services</h3>
          <p>Technical development, technical consulting, technical exchange, technology transfer and promotion, complemented by network and information technology consulting services.</p>
        </article>
        <article class="card">
          <h3>Products &amp; R&amp;D</h3>
          <p>Focused on IoT technology R&amp;D and technical services, AI hardware, commercial cryptography products, and the manufacturing and sales of other electronic devices.</p>
        </article>
        <article class="card">
          <h3>Trade &amp; Distribution</h3>
          <p>Integrated coordination of domestic trade agency, online sales, import &amp; export of goods and technology, import &amp; export agency and international freight forwarding.</p>
        </article>
      </section>

      <section class="timeline">
        <h2>Standard Business Execution Process</h2>
        <div class="steps">
          <div class="step">
            <h4>01 / Requirement Discussion</h4>
            <p>Clarify technical requirements, product categories and delivery goals, and provide matched solutions and quotation paths.</p>
          </div>
          <div class="step">
            <h4>02 / Solution Delivery</h4>
            <p>Advance technical development, product supply and channel onboarding, completing delivery and acceptance at each milestone.</p>
          </div>
          <div class="step">
            <h4>03 / Fulfillment &amp; Review</h4>
            <p>Follow up on logistics fulfillment, after-sales support and cooperation review to continuously improve the efficiency of future collaboration.</p>
          </div>
        </div>
      </section>

      <section class="metrics">
        <div class="metric">
          <p class="num">Multi-Category</p>
          <p class="txt">Covering technology, smart hardware, jewelry craftsmanship and daily consumer goods</p>
        </div>
        <div class="metric">
          <p class="num">Full-Chain</p>
          <p class="txt">Closed-loop service from R&amp;D and production to trade agency and logistics fulfillment</p>
        </div>
        <div class="metric">
          <p class="num">Compliance</p>
          <p class="txt">All general and licensed items are carried out in accordance with applicable regulations</p>
        </div>
      </section>

      <section class="company">
        <h2>Company Information</h2>
        <ul class="company-list">
          <li>
            <span class="k">Country / Region of Registration</span>
            <span class="v">Singapore</span>
          </li>
          <li>
            <span class="k">Enterprise certificate type</span>
            <span class="v">ACRA Business Profile</span>
          </li>
          <li>
            <span class="k">Registered Legal Name (Local Language)</span>
            <span class="v">POSITIVE UP PTE. LTD.</span>
          </li>
          <li>
            <span class="k">Registered Legal Name (English)</span>
            <span class="v">POSITIVE UP PTE. LTD.</span>
          </li>
          <li>
            <span class="k">Unique Entity Number</span>
            <span class="v">202643218C</span>
          </li>
          <li>
            <span class="k">Registered Address</span>
            <span class="v">71 UBI ROAD 1, #08-34, OXLEY BIZHUB, SINGAPORE 408732</span>
          </li>
          <li>
            <span class="k">Business License Expiry Date</span>
            <span class="v">None</span>
          </li>
        </ul>
      </section>

      <section class="company">
        <h2>Business Scope</h2>
        <div class="scope-block">
          <h3 class="scope-title">General Items</h3>
          <p class="scope-text">
            Technical services, technical development, technical consulting, technical exchange, technology transfer and promotion; domestic trade agency; network technical services; information technology consulting services; sales of commercial cryptography products; production of commercial cryptography products; jewelry manufacturing; jewelry retail; AI hardware sales; electronic product sales; retail of arts, crafts and collectibles (excluding ivory and its products); sales of gifts and flowers; sales of daily necessities; retail of computer software and hardware and auxiliary equipment; sales of communication devices; retail of auto parts; import and export of goods; import and export of technology; international freight forwarding; food sales (pre-packaged food only); online food sales (pre-packaged food only); online sales (excluding goods requiring licenses); manufacturing of other electronic devices; retail of hardware products; retail of apparel; sales of outdoor products; sales of lighting fixtures; import and export agency; IoT technology R&amp;D; IoT technical services. (Except for items subject to approval by law, business activities are carried out independently in accordance with the business license.)
          </p>
        </div>
        <div class="scope-block">
          <h3 class="scope-title">Licensed Items</h3>
          <p class="scope-text">
            Road freight transportation (excluding dangerous goods). (For items subject to approval by law, business activities may only be carried out after approval by the relevant authorities, and the specific items shall be based on the approval documents or licenses issued by the relevant authorities.)
          </p>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: "AboutView"
};
</script>

<style scoped>
.about-page {
  width: 100%;
  max-width: 800px;
  margin: 0 auto;
  padding: 20px 0;
  color: #eff5f8;
}

.about-hero {
  margin-bottom: 48px;
  text-align: center;
}


h1 {
  margin: 12px 0 16px;
  font-size: 32px;
  line-height: 1.3;
}

.desc {
  margin: 0 auto;
  max-width: 640px;
  color: #9ab0bc;
  line-height: 1.8;
  font-size: 15px;
}

.content-body {
  display: flex;
  flex-direction: column;
  gap: 48px;
}

h2 {
  margin: 0 0 24px;
  font-size: 22px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding-bottom: 12px;
}

.about-grid {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
}

.card h3 {
  margin: 0 0 8px;
  font-size: 18px;
  color: #ff6f2c;
}

.card p, .step p {
  margin: 0;
  line-height: 1.7;
  color: #9ab0bc;
  font-size: 14px;
}

.steps {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.step h4 {
  margin: 0 0 8px;
  font-size: 16px;
}

.metrics {
  display: grid;
  gap: 32px;
  grid-template-columns: repeat(3, 1fr);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding-top: 32px;
}

.metric {
  text-align: center;
}

.num {
  margin: 0 0 8px;
  font-size: 20px;
  font-weight: 700;
  color: #ffb684;
}

.txt {
  margin: 0;
  color: #9ab0bc;
  line-height: 1.5;
  font-size: 14px;
}

.company-list {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 12px;
}

.company-list li {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 12px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.company-list .k {
  color: #ffb684;
  font-size: 13px;
  font-weight: 700;
}

.company-list .v {
  color: #eff5f8;
  font-size: 14px;
  line-height: 1.6;
  word-break: break-word;
}

.scope-block {
  padding: 14px 16px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.scope-block + .scope-block {
  margin-top: 12px;
}

.scope-title {
  margin: 0 0 8px;
  font-size: 15px;
  color: #ff6f2c;
}

.scope-text {
  margin: 0;
  color: #9ab0bc;
  font-size: 14px;
  line-height: 1.9;
}

@media (max-width: 640px) {
  .company-list li {
    grid-template-columns: 1fr;
    gap: 4px;
  }
}

@media (max-width: 768px) {
  .about-grid, .metrics {
    grid-template-columns: 1fr;
    gap: 24px;
  }
}

@media (max-width: 768px) {
  .about-page {
    padding: 10px 0 0;
  }

  .about-hero {
    margin-bottom: 26px;
  }

  h1 {
    margin: 10px 0 12px;
    font-size: 24px;
    line-height: 1.35;
  }

  .desc {
    font-size: 14px;
    line-height: 1.75;
  }

  .content-body {
    gap: 26px;
  }

  h2 {
    margin: 0 0 16px;
    font-size: 19px;
  }

  .about-grid,
  .metrics {
    gap: 18px;
  }

  .metrics {
    padding-top: 20px;
  }

  .card h3 {
    font-size: 16px;
  }

  .card p, .step p,
  .txt,
  .scope-text {
    font-size: 13px;
    line-height: 1.8;
  }

  .steps {
    gap: 16px;
  }

  .step h4 {
    margin: 0 0 6px;
    font-size: 15px;
  }

  .company-list {
    gap: 8px;
  }

  .company-list li {
    padding: 10px 12px;
    gap: 6px;
  }

  .company-list .v {
    font-size: 13px;
    line-height: 1.7;
  }

  .scope-block {
    padding: 12px;
  }

  .scope-title {
    font-size: 14px;
  }
}

@media (max-width: 480px) {
  .company-list .k {
    font-size: 12px;
  }

  .about-grid,
  .metrics {
    gap: 14px;
  }

  .num {
    margin-bottom: 4px;
    font-size: 18px;
  }
}
</style>
